import C from './constants'

export const setFiles = (values) => (
    {
        type: C.SET_FILES,
        payload: values 
    }
)
